import { Box, Button, Divider, Paper, Typography } from '@mui/material'

import { IMovementsResponse } from '../types'

interface IProps {
  data: IMovementsResponse
  onVigenciasClick?(): void
}

const fmt = new Intl.NumberFormat('pt-BR')

export function Movements({ data, onVigenciasClick }: IProps) {
  const rows: Array<{ label: string; value: string; code: string }> = [
    { label: 'Pendentes', value: fmt.format(data.mov_pendentes), code: 'K4' },
    { label: 'Aprovações no período', value: fmt.format(data.aprovacoes_periodo), code: 'K5' },
    { label: 'Inclusões', value: fmt.format(data.inclusoes), code: 'K14' },
    { label: 'Exclusões', value: fmt.format(data.exclusoes), code: 'K15' },
    { label: 'Dias médio pendente', value: data.dias_medio_pendente !== null ? data.dias_medio_pendente.toFixed(1) : '—', code: 'K16' },
    { label: 'Retificações', value: fmt.format(data.mov_rectify), code: 'K17' },
    { label: 'Retidas', value: fmt.format(data.mov_held), code: 'K18' },
  ]
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      {rows.map(r => (
        <Box key={r.code} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
          <Typography variant="body2">{r.label} <Typography component="span" variant="caption" color="text.secondary">({r.code})</Typography></Typography>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>{r.value}</Typography>
        </Box>
      ))}
      {onVigenciasClick && (
        <>
          <Divider sx={{ my: 1 }} />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button size="small" onClick={onVigenciasClick}>Ver vigências alteradas</Button>
          </Box>
        </>
      )}
    </Paper>
  )
}
